module.exports = __webpack_public_path__ + "static/media/IMG_7519-min.f653d239.JPG";